
import ApplicationTitle from '../../components/ApplicationTitle';
import FormTitle from '../../components/form_titles/FormTitle';
import TextBox from '../../components/input_fields/TextBox';
import TextInput from '../../components/input_fields/TextInput';
import DoubleButton from '../../components/buttons/DoubleButton';
import validator from "validator";
import React, { useState } from "react";
import ProgressBar from '../../components/progress/ProgressBar';

export default function Step2({ nextStep, handleFormData, prevStep, values, validation, color }) {

  const [textBoxError, setTextBoxError] = useState(false)
  const [mccsccError, setmccsccError] = useState(false)

  const submitFormData = (e) => {
    e.preventDefault();
    //Errors
    if (validation) {
      if (values.mcc_Iso !== "N/A") {
        if (values.mcc_Iso.length !== 4 || !validator.isNumeric(values.mcc_Iso)) {
          setmccsccError(true)
          return
        } setmccsccError(false)
      } setmccsccError(false)


      if (validator.isEmpty(values.busDesc)) {
        setTextBoxError(true)
        return
      } setTextBoxError(false)
    }

    nextStep();

  };

  return (
    <div className="bg-white-900 dark:bg-white-900">
      <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
        {/* <ApplicationTitle
          mainTitle="Bipsypay Merchant Application"
          subTitle="Complete the form below to begin your Bipsypay merchant application"
        /> */}
        <ProgressBar
          progress="24%"
          color={color}
        />
        <div className="bg-white rounded-lg shadow dark:border width-screen xl:p-0">
          <div className="p-6 space-y-1 sm:p-8">
            <FormTitle
              color={color}
              mainTitle="Let's talk"
              colorTitle="business"
              subText="Briefly explain the services you provide and/or products you sell."
              modalTitle="What are you looking for… "
              modalDesc="We need a SIC or MCC for your business but it can be difficult to find so… just tell us what you do and who you serve and we can take care of the rest. While technically different things, the Standard Industrial Classification (SIC) code and Merchant Category Code (MCC) are essentially both systems the credit card industry uses to identify industry types using a four-digit code. Your merchant MCC/SIC code is determined at the time you apply for a merchant account and is based on the industry specified on your application to describe your business."
            />
            <form className="space-y-4" onSubmit={submitFormData}>
              <TextInput
                color={color}
                placeholder="I know my MCC/SIC Code, it is... (4 digits)" name="mcc_Iso" value={values.mcc_Iso}
                error={mccsccError} message={'Must be four digits. (Type "N/A" if you don\'t know it.)'}
                handleInputChange={handleFormData}
              />

              <TextBox
                color={color}
                placeholder="I don't know my MCC/SIC code. My business primarily deals in..." name="busDesc" value={values.busDesc}
                error={textBoxError} message={'Please provide a short description of your business.'}
                handleInputChange={handleFormData}
              />

              <DoubleButton color = {color} prevStep={prevStep}></DoubleButton>
              
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}